import {
	ChangeDetectionStrategy,
	Component,
	inject,
	Input,
} from '@angular/core';
import { ManagementTypes } from '@models/matter';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';

@Component({
	selector: 'app-sale-condo-management-type',
	templateUrl: './condo-management-type.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CondoManagementTypeComponent {
	@Input() public labelOrientation: 'row' | 'col' = 'col';
	public managementTypes = [
		{ label: 'Management Company', value: ManagementTypes.MANAGEMENT_COMPANY },
		{ label: 'Self-managed', value: ManagementTypes.SELF_MANAGED },
	];

	public managementType$ = inject(Store)
		.select(SelectedMatter.condoCorporation)
		.pipe(map((condo) => condo?.managementType));

	constructor(private matterDispatch: MatterDispatch) {}

	setManagementType(managementType: ManagementTypes) {
		this.matterDispatch.OverwriteFields(
			'condoCorporation.managementType',
			managementType,
		);
	}
}
